import { render, staticRenderFns } from "./PrevIcon.vue?vue&type=template&id=65d6cde0&scoped=true&"
import script from "./PrevIcon.vue?vue&type=script&lang=ts&"
export * from "./PrevIcon.vue?vue&type=script&lang=ts&"
import style0 from "./PrevIcon.vue?vue&type=style&index=0&id=65d6cde0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d6cde0",
  null
  
)

export default component.exports